import Vue from 'vue'
import Badge from '@/components/Badge'
import KiBolt from '@/components/KiBolt'
import Etiktronic from '@/components/Etiktronic'
import HelloWorld from '@/components/HelloWorld'
import Home from '@/components/Home'
import Router from 'vue-router'
import Setup from '@/components/Setup'
import SetupUsb from '@/components/SetupUsb'
import SetupKiProg from '@/components/SetupKiProg'
import Tools from '@/components/Tools'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/',
      name: 'Default',
      component: Home
    },
    {
      path: '/setup',
      name: 'Setup',
      component: Setup
    },
    {
      path: '/tools',
      name: 'Tools',
      component: Tools
    },
    {
      path: '/usb',
      name: 'SetupUsb',
      component: SetupUsb
    },
    {
      path: '/kiprog',
      name: 'SetupKiProg',
      component: SetupKiProg
    },
    {
      path : '/badge',
      name: 'Badge',
      component: Badge
    },
    {
      path : '/kibolt',
      name: 'KiBolt',
      component: KiBolt
    },
    {
      path : '/etiktronic',
      name: 'Etiktronic',
      component: Etiktronic
    }

  ]
})
